<template>
  <div class="animated fadeIn col-md-12">
    <SearchCard
      :filterCatch="true"
      :title="$lang.surveyLang.all_survey_list"
      :url="$config.api_url + $config.survey.all_survey"
      :html="false"
      :allowFields="$lang.search_parvandeh_fildes"
      ref="allSurvey"
      @updatePermissions="updatePermissions"
      :hasAdd="true"
      @handleAdd="goToAddSurvey"
    >
      <template slot="html" slot-scope="{ item }">
        <b-row class="mx-0">
          <b-col
            cols="12"
            class="py-1 mb-3 border-bottom d-flex align-items-center justify-content-between"
          >
            <div class="d-flex align-items-center">
              <span
                class="mr-1 fs_1_3rem w_h_35 border bg-light rounded-circle d-flex align-items-center justify-content-center"
              >
                <i class="fas fa-comments text-secondary" />
              </span>
              <b
                class="px-1 fs_1rem"
                v-text="`${pathOr('', ['survey_group', 'name'], item)}`"
              />
            </div>
            <small class="text-muted">
              <div
                v-b-tooltip
                title="ثبت کننده"
                v-if="
                  pathOr(
                    null,
                    ['operator_parvandeh', 'person', 'full_name'],
                    item
                  )
                "
              >
                <i class="fas fa-user mr-1" />
                <span
                  v-text="
                    pathOr(
                      '',
                      ['operator_parvandeh', 'person', 'full_name'],
                      item
                    )
                  "
                />
              </div>
              <div v-b-tooltip title="زمان ایجاد">
                <i class="fas fa-clock mr-1" />
                <span v-text="pathOr('', ['created_at', 'jalali'], item)" />
              </div>
            </small>
          </b-col>
          <b-col cols="12" md="6" class="mb-3">
            <div
              class="bg-info rounded-top text-center font-weight-bold p-2"
              v-text="'نظر دهنده'"
            />
            <b-row class="mx-0 bg-light rounded-bottom py-3">
              <b-col cols="12" md="auto" class="text-md-left text-center">
                <ImageBox
                  :downloadCode="
                    pathOr(
                      '',
                      ['operator_parvandeh', 'person', 'download_code'],
                      item
                    )
                  "
                  :defaultImage="defaultImage"
                  wrapperClass="flex-center"
                  imageClass="width-120 height-120 rounded-lg"
                  loadingClass="width-120 height-120 rounded-lg"
                />
              </b-col>
              <b-col cols="12" md="">
                <b-row>
                  <b-col cols="12" md="12" class="flex-start">
                    <i class="fas fa-user text-info mr-1" />
                    <ProfileBoxPopupWrapper
                      :data="item.operator_parvandeh"
                      deskTopPopupClass="top-230"
                      nameClass="color-complementary"
                    />
                  </b-col>
                  <b-col cols="12" md="12" class="py-2">
                    <i class="fas fa-address-card text-info mr-1" />
                    <span
                      class="text-muted"
                      v-b-tooltip.hover
                      :title="$lang.surveyLang.national_code"
                      v-text="
                        pathOr(
                          '',
                          ['operator_parvandeh', 'person', 'national_code'],
                          item
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="12" md="12">
                    <i class="fas fa-folder text-info mr-1" />
                    <span
                      class="text-muted"
                      v-b-tooltip.hover
                      :title="$lang.surveyLang.parvandeh_number"
                      v-text="
                        pathOr(
                          '',
                          [
                            'operator_parvandeh',
                            'parvandeh',
                            'parvandeh_number',
                          ],
                          item
                        )
                      "
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6">
            <div
              class="bg-success rounded-top text-center font-weight-bold p-2"
              v-text="'نظر درباره'"
            />
            <b-row class="mx-0 bg-light rounded-bottom py-3">
              <b-col cols="12" md="auto" class="text-md-left text-center">
                <ImageBox
                  :downloadCode="
                    pathOr(
                      '',
                      ['person_parvandeh', 'person', 'download_code'],
                      item
                    )
                  "
                  :defaultImage="defaultImage"
                  wrapperClass="flex-center"
                  imageClass="width-120 height-120 rounded-lg"
                  loadingClass="width-120 height-120 rounded-lg"
                />
              </b-col>
              <b-col cols="12" md="">
                <b-row>
                  <b-col cols="12" md="12" class="flex-start">
                    <i class="fas fa-user text-success mr-1" />
                    <ProfileBoxPopupWrapper
                      :data="item.person_parvandeh"
                      deskTopPopupClass="top-230"
                      nameClass="color-complementary"
                    />
                  </b-col>
                  <b-col cols="12" md="12" class="py-2">
                    <i class="fas fa-address-card text-success mr-1" />
                    <span
                      class="text-muted"
                      v-b-tooltip.hover
                      :title="$lang.surveyLang.national_code"
                      v-text="
                        pathOr(
                          '',
                          ['person_parvandeh', 'person', 'national_code'],
                          item
                        )
                      "
                    />
                  </b-col>
                  <b-col cols="12" md="12">
                    <i class="fas fa-folder text-success mr-1" />
                    <span
                      class="text-muted"
                      v-b-tooltip.hover
                      :title="$lang.surveyLang.parvandeh_number"
                      v-text="
                        pathOr(
                          '',
                          ['person_parvandeh', 'parvandeh', 'parvandeh_number'],
                          item
                        )
                      "
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="12">
            <b-row align-v="center" class="mt-3">
              <b-col cols="12" class="py-1">
                <i class="fas fa-comment text-secondary mr-1" />
                <span
                  class="text-muted"
                  v-html="nl2br(pathOr('', ['survey_text'], item))"
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="py-1 mt-3 border-top d-flex align-items-center justify-content-between"
          >
            <div />
            <div>
              <b-button
                variant="outline-success"
                size="sm"
                @click="goToEditSurvey(item)"
              >
                <i class="fas fa-edit mr-1" />
                <b v-text="$lang.show" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </template>
    </SearchCard>
  </div>
</template>

<script>
import SearchCard from "@/components/base/searchCard";
import { pathOr, includes } from "ramda";
import { generateConfig, generateStoreGetters, nl2br } from "@/shared/utils";
import { ProfileBoxPopupWrapper, ImageBox } from "@/components/re-design";

export default {
  components: {
    SearchCard,
    ProfileBoxPopupWrapper,
    ImageBox,
  },
  data() {
    return {
      permissions: [],
    };
  },
  computed: {
    roles() {
      return generateStoreGetters(["userInfo", "roles"]) || [];
    },

    defaultImage() {
      return generateConfig([
        "images",
        "shared",
        "redesign",
        "empty",
        "noUser",
      ]);
    },
  },
  methods: {
    pathOr,
    includes,
    nl2br,
    async getData() {
      await this.$refs.allSurvey.getItems();
      this.$emit("updateRefreshGetData", false);
    },
    updatePermissions(data) {
      this.permissions = [...data];
    },
    goToAddSurvey() {
      return this.$router.push({ name: "survey" });
    },
    goToEditSurvey(item) {
      const { code } = item;
      return this.$router.push({ name: "view_survey", params: { code } });
    },
  },
};
</script>

<style scoped lang="scss">
.grid-img-crd {
  /* width: 150px;
  height: auto;
  margin: auto;
  display: block; */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  img {
    width: 95px;
    height: auto;
  }
}
.fs_1_3rem {
  font-size: 20px;
}
.w_h_35 {
  width: 35px;
  height: 35px;
}
</style>
